import axios from 'axios'
import { msalInstance, loginRequest } from './msalConfig'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL
    ? `${import.meta.env.VITE_API_BASE_URL}/api`
    : '/api',
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use(async (config) => {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    try {
      const result = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      config.headers.Authorization = `Bearer ${result.accessToken}`
    } catch {
      await msalInstance.loginRedirect(loginRequest)
    }
  }
  return config
})

export interface ShortenRequest {
  originalUrl: string
  alias?: string
  expiresAt?: string
}

export interface ShortenResponse {
  shortCode: string
  shortUrl: string
  originalUrl: string
  createdAt: string
  expiresAt: string | null
}

export interface ShortenedUrl {
  id: number
  originalUrl: string
  shortCode: string
  alias: string | null
  createdAt: string
  expiresAt: string | null
  clickCount: number
  isActive: boolean
  createdBy: string | null
}

export interface UrlStats {
  shortCode: string
  originalUrl: string
  clickCount: number
  createdAt: string
  expiresAt: string | null
  isActive: boolean
  createdBy: string | null
  recentClicks: ClickEvent[]
}

export interface ClickEvent {
  id: number
  clickedAt: string
  userAgent: string | null
  ipAddress: string | null
  referrer: string | null
}

export const shortenUrl = (req: ShortenRequest) =>
  api.post<ShortenResponse>('/urls/shorten', req).then(r => r.data)

export const getUrls = (page = 1, pageSize = 20, search?: string) =>
  api.get<ShortenedUrl[]>('/urls', { params: { page, pageSize, ...(search ? { search } : {}) } }).then(r => r.data)

export const getStats = (code: string) =>
  api.get<UrlStats>(`/urls/${code}/stats`).then(r => r.data)

export const deleteUrl = (code: string) =>
  api.delete(`/urls/${code}`)

export const renewUrl = (code: string, expiresAt?: string) =>
  api.put<ShortenedUrl>(`/urls/${code}/renew`, { expiresAt: expiresAt ?? null }).then(r => r.data)
